import React from "react";
import { Text, View } from "react-native";
import { EStyleSheet, useDynamicStyles } from "react-native-extended-stylesheet-typescript";
import { useServices } from "../../contexts/ServiceContext";
import { SubmittedCheckmarkIcon } from "../icons/SubmittedCheckmarkIcon";
import { GlobalStyles } from "../style/Style";

export const ThanksForPlaying: React.FC = () => {
    const { edgeDeploy } = useServices();
    const styles = useDynamicStyles(generateStyles);

    return (
        <View style={styles.container}>
            <View style={styles.icon}>
                <SubmittedCheckmarkIcon
                    width={140}
                    height={140}
                    fill={EStyleSheet.value(GlobalStyles.SUBMITTED_CHECKMARK)}
                />
            </View>
            <Text style={[styles.title, edgeDeploy && styles.edgeTitle]}>Thank you for playing!</Text>
        </View>
    );
};

const generateStyles = () => {
    return EStyleSheet.create({
        container: {
            width: "100%",
            paddingHorizontal: 10,
        },
        icon: {
            alignSelf: "center",
        },
        title: {
            fontSize: 24,
            lineHeight: 24,
            textAlign: "center",
            color: () => EStyleSheet.value(GlobalStyles.THANKS_TEXT),
            fontFamily: () => EStyleSheet.value(GlobalStyles.HEADER_FONT),
        },
        edgeTitle: {
            fontSize: 48,
        },
    });
};
